import { requireNativeModule } from 'expo-modules-core';

// TODO: Rename the package to 'ExpoMail'
export default requireNativeModule('ExpoMailComposer');
